module.exports = __webpack_public_path__ + "static/media/ad-banner.524e6f47.png";